import { createReducer } from '@reduxjs/toolkit';

import * as contentActions from './contentActions.js';

const initialState = {
  id: 0,
  uid: 0,
  type: '',
  isActive: false,

  headingTitle: '',
  headingDescription: '',
  items: [],

  code: '',
  terms: '',

  label: '',
  endDate: '',
};

const content = createReducer(initialState, (builder) => {
  builder
    .addCase(contentActions.contentStore, (state, { payload: section }) => {
      const data = section?.[section?.type] ?? {};

      return {
        ...state,
        id: section?.blockId ?? 0,
        uid: section?.uid ?? 0,
        type: section?.type ?? '',
        isActive: section?.isActive ?? false,
        headingTitle: data.headingTitle ?? '',
        headingDescription: data.headingDescription ?? '',
        items: data.items ?? [],
        code: data.code ?? '',
        terms: data.terms ?? '',
        label: data.label ?? '',
        endDate: data.endDate ?? '',
      };
    })
    .addCase(contentActions.contentClear, () => ({ ...initialState }))

    .addCase(contentActions.contentUpdateHeadingTitle, (state, { payload }) => ({ ...state, headingTitle: payload }))
    .addCase(contentActions.contentUpdateHeadingDescription, (state, { payload }) => ({ ...state, headingDescription: payload }))
    .addCase(contentActions.contentUpdateItems, (state, { payload }) => ({ ...state, items: payload }))
    .addCase(contentActions.contentUpdateCode, (state, { payload }) => ({ ...state, code: payload }))
    .addCase(contentActions.contentUpdateTerms, (state, { payload }) => ({ ...state, terms: payload }))
    .addCase(contentActions.contentUpdateLabel, (state, { payload }) => ({ ...state, label: payload }))
    .addCase(contentActions.contentUpdateEndDate, (state, { payload }) => ({ ...state, endDate: payload }));
});

export default content;
